import { Button } from '@mui/material';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  color: green;
`;
